export default __webpack_public_path__ + "static/media/gear_colored.fa861582.svg";